import * as React from 'react'
import { observer } from 'mobx-react'

import OpportunitiesViewModel from 'opportunities/OpportunitiesViewModel'

import styles from './OverachieverBanner.sass'
import Link from 'components/Link'
import link from 'infra/link'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: OpportunitiesViewModel
}

export default observer(function OverachieverBanner({ vm }: Props) {
  let shouldDisplayWorkspaceText = true

  const totalOfWorkspaceWithoutCapacity =
    vm.workspacesWithoutPickUpCapacity.length

  const workspacesDisplayText =
    totalOfWorkspaceWithoutCapacity === 1
      ? `in the ${vm.workspacesWithoutPickUpCapacity[0].name} workspace`
      : `across ${totalOfWorkspaceWithoutCapacity} workspaces`

  // if the specific workspace is not found, we should not display
  // the workspace text
  if (vm.searcher.workspaceFilter.type === 'SpecificWorkspace') {
    const workspace = vm.searcher.workspaceFilter.workspace

    shouldDisplayWorkspaceText = !vm.workspacesWithoutPickUpCapacity.some(
      (x) => x.id === workspace.id,
    )
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.title}>
          You’ve reached your pickup limit
          {vm.canPickUpOpportunityGlobally && shouldDisplayWorkspaceText && (
            <span> {workspacesDisplayText}</span>
          )}
          !
        </div>
        <div className={styles.description}>
          To unlock more opportunities, please complete some of your open jobs
          first.
        </div>

        <Link to={link.jobs()} className={styles.finishButton}>
          Finish Open Jobs
        </Link>
      </div>
      <div className={styles.illustrationContainer}>
        <img
          className={styles.illustration}
          src={require('assets/images/img_archive.svg')}
          alt="Illustration of a hand putting a book on a shelf"
        />
      </div>
    </div>
  )
})
